export const TASK_ASYNC="/add_task_async";
export const TASK_STATUS="/get_status";
export const TASK_RESULT_FILE="/get_result_files";
export const TASK_STATIC_RESULT="/get_kdd_static";
export const TASK_SYNC="/add_task_sync";
export const TASK_SYNC_WITH_FILE="/add_task_sync_with_file";
export const UPLOAD_FILE="/upload";
// export const TASK_SYNC_OLD="/add_task_sync_previous";
export const GET_ARRAY_DATA="/get_array_data";